// styles.js
import styled from "styled-components";

export const Section = styled.div`
  display: flex;
  flex: 1;
  max-width: 100%;
  /* flex-direction: column; */
  padding: 16px;
`;

// export const Column = styled.div`
//   display: flex;
//   flex-direction: column;
//   flex: 1;
//   max-width: 100%;
// `;
